import styled from '@emotion/styled';

import ChevronDown from '~/icons/iconography/chevron/down.svg';

export const StyledSelect = styled.div(({ theme }) => ({
    outline: 'none',
    cursor: 'pointer',
    top: theme.space[2],
}));

export const StyledTextWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    color: theme.colors.grey70,
    fontSize: theme.fontSizes.guinea,
    gap: theme.space[1],
    width: 160,
    '&:focus-visible': {
        outline: 'none',
    },
}));

export const StyledText = styled.span(() => ({
    color: 'inherit',
}));

export const StyledList = styled.ul((props) => ({
    position: 'absolute',
    width: 160,
    padding: 0,
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.08), 0px 8px 12px 0px rgba(0, 0, 0, 0.08)',
    zIndex: 1323,
}));

export const StyledListItem = styled.li<{ highlighted: boolean }>(({ theme, highlighted }) => ({
    border: `solid 1px ${theme.colors.grey10}`,
    paddingInline: theme.space[4],
    paddingBlock: theme.space[3],
    backgroundColor: theme.colors.white,
    outline: highlighted ? `solid 1px ${theme.colors.grey50}` : 'none',
    zIndex: 1,
    cursor: 'pointer',
}));

export const StyledChevron = styled(ChevronDown)(({ theme }) => ({
    color: theme.colors.black,
}));

export const StyledEmptyBox = styled.div(({ theme }) => ({
    backgroundColor: theme.colors.white,
    width: '100%',
    minHeight: 500,
    color: theme.colors.grey70,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));
